import React from 'react';

function QuoteLeft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M11.13,7.07Q10,7.7,9.35,8.16A8.21,8.21,0,0,0,8,9.36a5.5,5.5,0,0,0-1,1.47,6.7,6.7,0,0,0-.49,2H7.59a3.39,3.39,0,0,1,2.29.71,2.61,2.61,0,0,1,.83,2.1A2.77,2.77,0,0,1,10,17.47a2.54,2.54,0,0,1-2,.86A3.19,3.19,0,0,1,5.06,17a6.24,6.24,0,0,1-.87-3.47,5.88,5.88,0,0,1,.66-2.77A9.83,9.83,0,0,1,6.45,8.53a11.51,11.51,0,0,1,2-1.71q1.08-.7,1.8-1.15Zm8.67,0Q18.7,7.7,18,8.16a8.21,8.21,0,0,0-1.38,1.2,5.43,5.43,0,0,0-1,1.48,6.82,6.82,0,0,0-.48,2h1.13a3.39,3.39,0,0,1,2.29.71,2.61,2.61,0,0,1,.83,2.1,2.77,2.77,0,0,1-.74,1.84,2.54,2.54,0,0,1-2,.86A3.19,3.19,0,0,1,13.73,17a6.24,6.24,0,0,1-.87-3.47,5.88,5.88,0,0,1,.66-2.77,9.83,9.83,0,0,1,1.59-2.23,11.51,11.51,0,0,1,2-1.71q1.08-.7,1.8-1.15Z" />
    </svg>
  );
}

export default QuoteLeft;



// WEBPACK FOOTER //
// ./src/common/icons/QuoteLeft.js